import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../progress-indicators/spinner/spinner.component';
import { ProgressComponent } from './progress/progress.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    SpinnerComponent,
    ProgressComponent
  ],
  exports: [
    SpinnerComponent,
    ProgressComponent
  ]
})
export class ProgressIndictatorsModule { }
